export enum messageTypeEnum {
	FOR_AUTOMATING_BA = 'forAutomatingBA',
	FOR_PROCURING_CARRIERS = 'forProcuringCarriers',
}

export type messageType =
	| messageTypeEnum.FOR_AUTOMATING_BA
	| messageTypeEnum.FOR_PROCURING_CARRIERS;
